import React from "react";
import styles from "./ValidationCGU.scss";
import AppRow from "src/commun/composants/grille/AppRow";
import AppCol from "src/commun/composants/grille/AppCol";
import ValidationCGUForm from "src/pages/validationCGU/form/ValidationCGUForm";
import { AcceptCGU } from "src/pages/validationCGU/form/useValidationSchemaValidationCGU";

const ValidationCGU = () => {

  return  (
    <span className={`ferge-class`}>
      <AppRow className="justify-content-md-center">
        <AppCol md={{span: 11}} className={styles.formContainer}>
          <ValidationCGUForm initialValues={{} as AcceptCGU} />
        </AppCol>
      </AppRow>
    </span>
  );
};

export default ValidationCGU;